import sortBy from 'lodash.sortby';

const order = ['FNAME', 'LNAME', 'PHONE', 'ADDRESS', 'BIRTHDAY'];

export const sortingListMergeFields = (fields: any) => {
  const orderMap = {};
  order.forEach(i => {
    orderMap[i] = order.indexOf(i);
  });

  const sortedFields = sortBy(fields, obj => {
    return orderMap[obj['tag']];
  });

  return sortedFields;
};
